import { apiClient } from "@/lib/apiClient";
import type {
  UserPointsLeaderboardResponseDto,
  UserPointsMeDto,
} from "../types/user-points.types";

function unwrap<T>(payload: unknown): T {
  const env = payload as { data?: T } | T | null | undefined;
  if (env && typeof env === "object" && "data" in (env as object)) {
    const inner = (env as { data?: T }).data;
    if (inner !== undefined) return inner as T;
  }
  return payload as T;
}

export const userPointsApi = {
  getMyPoints: async (): Promise<UserPointsMeDto> => {
    const { data } = await apiClient.get<UserPointsMeDto>("/api/user-points/me");
    return unwrap<UserPointsMeDto>(data);
  },

  getLeaderboard: async (
    page = 1,
    limit = 10,
  ): Promise<UserPointsLeaderboardResponseDto> => {
    const { data } = await apiClient.get<UserPointsLeaderboardResponseDto>(
      "/api/user-points/leaderboard",
      { params: { page, limit } },
    );
    return unwrap<UserPointsLeaderboardResponseDto>(data);
  },
};
